import { supabase } from "@/integrations/supabase/client";
import type { DiscoverySearchPort, DiscoverySearchRpcRow } from "../ports/discoverySearch.port";
import type { DiscoveryProfilePort, DiscoveryProfileRpcData } from "../ports/discoveryProfile.port";
import type { NormalizedDiscoveryFilters } from "../types/discoveryFilter.types";

export class SupabaseDiscoveryRepository implements DiscoverySearchPort, DiscoveryProfilePort {
  async searchInfluencers(
    filters: NormalizedDiscoveryFilters,
    userCountry?: string | null
  ): Promise<DiscoverySearchRpcRow[]> {
    const { data, error } = await supabase.rpc("search_discovery_influencers", {
      p_search_query: filters.searchTerm,
      p_platforms: filters.platforms.length > 0 ? filters.platforms : null,
      p_tier: filters.tier,
      p_location: filters.location,
      p_category: filters.category,
      p_language: filters.language,
      p_min_followers: filters.minFollowers,
      p_max_followers: filters.maxFollowers,
      p_min_engagement: filters.minEngagement,
      p_max_engagement: filters.maxEngagement,
      p_gender: filters.gender,
      p_limit: filters.limit,
      p_offset: filters.offset,
      p_user_country: userCountry || null,
    });

    if (error) {
      if (error.code === "P0001" && error.message?.includes("Rate limit")) {
        throw new Error("Too many searches. Please wait a moment.");
      }
      throw error;
    }

    return (data as unknown as DiscoverySearchRpcRow[]) || [];
  }

  async getProfileByHandle(cleanHandle: string): Promise<DiscoveryProfileRpcData | null> {
    const { data, error } = await supabase
      .rpc("get_discovery_influencer_profile", { p_handle: cleanHandle })
      .maybeSingle();

    if (error) throw error;
    return (data as unknown as DiscoveryProfileRpcData) || null;
  }

  async getInfluencerEmail(influencerId: string): Promise<string | null> {
    const { data, error } = await supabase.rpc("get_influencer_email", {
      influencer_id: influencerId,
    });

    if (error) throw error;
    return (data as string) || null;
  }
}

export const discoveryRepository = new SupabaseDiscoveryRepository();
